import VenueContacts from './VenueContacts';
export default VenueContacts;
